import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import { api_gateway } from '../../../../conexoes/api'
import '../../../../css/painelFaturas/fatContestacao/tabela.css'
import { revelarEditarSolicitacao } from '../../../../redux/actions/index'
import {
    elipseVerde,
    fecharJanela,
    setaDropdown
} from '../../../../utils/alternanciaIcones'
import decryptJWT from '../../../../utils/decryptJWT'
import Calendario from '../../../calendario/calendario'
import MensagemAtencao from '../../../componentesModais/mensagens/mensagemAtencao'
import MensagemErro from '../../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../../componentesModais/mensagens/mensagemSucesso'
import SelectGenerico from '../../../componentesModais/selects/selectGenerico'
import SpinerVeye from '../../../spinnerVeye/spinnerVeye.js'

export default function EditarSolicitacao(props) {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [, setItens] = useState('')
  const { register, handleSubmit, } = useForm()
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [cdSolicitacao, setCdSolicitacao] = useState()
  const [tituloJanela, setTituloJanela] = useState('Nova')
  const [dataMax, ] = useState()
  const dataMin = 1990
  const [previsaoConclusao, setPrevisaoConclusao] = useState('')
  const [dataConclusao, setDataConclusao] = useState('')
  const [protocoloContestacao, setProtocoloContestacao] = useState()
  const [motivoAlteracao, setMotivoAlteracao] = useState()
  const [cdStatus, setCdStatus] = useState()
  const [dsStatus, setDsStatus] = useState('Selecione')
  const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [, setDummy] = useState('')
  const [revelarSelectCicloDeVida, setRevelarSelectCicloDeVida] =
    useState(false)
  const despacho = useDispatch()
  const modal = useRef()

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }


  useEffect(() => {
    setSpinAtivo(true)
    if (props.tituloJanela === 'Editar') {
      setTituloJanela('Editar')
      setCdSolicitacao(props.cdSolicitacao)
      setProtocoloContestacao(props.protocoloContestacao)
      setPrevisaoConclusao(new Date(props.dataPrazoConclusao))
      if (
        props.dataFim !== '' &&
        props.dataFim !== null &&
        props.dataFim !== undefined
      ) {
        setDataConclusao(new Date(props.dataFim))
      }
      setMotivoAlteracao(props.motivo)
      setCdStatus(props.cdStatus)
      setDsStatus(props.dsStatus)
    }

    document.addEventListener('mousedown', handleClickFora)
    setSpinAtivo(false)
    return () => document.removeEventListener('mousedown', handleClickFora)
  }, [])

  useEffect(() => {
    async function carregarTabela() {
      if (cdSolicitacao != undefined) {
        const { data } = await api_gateway.get(
          '/m1/consultar/fat_solicitacao_alteracao?cd_fat_solicitacao=' +
            cdSolicitacao
        )
        setItens(data.dados)
      }
    }
    carregarTabela()
  }, [cdSolicitacao])

  async function handleSalvar() {
    setSpinAtivo(true)

    if (tituloJanela === 'Editar') {
      await api_gateway
        .post(
          '/m1/alterar/fat_solicitacao',
          {
            dados: {
              cd_fat_solicitacao_status: cdStatus,
              ds_protocolo_contestacao: protocoloContestacao,
              dt_fim: moment(dataConclusao).format('YYYY-MM-DD hh:mm:ss'),
              dt_prazo_conclusao: moment(previsaoConclusao).format(
                'YYYY-MM-DD hh:mm:ss'
              ),
              ds_motivo: motivoAlteracao,
              cd_pav_usuario_created: decryptJWT('codigo')
            },
            condicao: {
              cd_fat_solicitacao: cdSolicitacao
            }
          },
          { timeout: 20000 }
        )
        .then(function () {
          setSpinAtivo(false)
          handleMensagemSucesso(false)
        })
        .catch(function () {
          setSpinAtivo(false)
          setMensagemErro('Erro na solicitação')
          handleMensagemErro(false)
        })
    }
    setSpinAtivo(false)
  }

  async function handleCancelar() {
    setSpinAtivo(false)
    props.setRenderizar(!props.renderizar)
    despacho(revelarEditarSolicitacao(false))
  }

  function handleMensagemAtencao() {
    if (revelarMensagemAtencao === false) {
      setRevelarMensagemAtencao(true)
    } else {
      setRevelarMensagemAtencao(false)
   
    }
  }

  function handleMensagemSucesso() {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      handleCancelar()
    }
  
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  return (
    <Form ref={modal} onSubmit={handleSubmit(() => handleSalvar())}>
      <div className="modal-acao-desativar-demonstracao fundo-cor-6">
        {spinAtivo && (
          <div className="componente-spinner-overlay">
            <div className="componente-spinner-container">
              <SpinerVeye />
            </div>
          </div>
        )}
        <Form.Row>
          <Col>
            <img
              className="icone-label-janela nao-selecionavel"
              src={elipseVerde()}
              alt="elipse"
            />
            <Form.Label>
              <div className="fonte-cor-1 label-janela">Editar solicitação</div>
            </Form.Label>
            <Button
              className="botao-fechar-janela"
              variant="danger"
              onClick={() => handleCancelar()}
            >
              <img
                className="botao-fechar-janela-icone"
                src={fecharJanela()}
                alt="fechar-janela"
              />
            </Button>
          </Col>
        </Form.Row>
        {/* CORPO */}
        <Form.Row className="usuario-dados-corpo-linha">
          <div className="corpo-dados-solicitacao">
            <Form.Label>
              <div className="fonte-cor-1 label-campo">Status</div>
            </Form.Label>
            {revelarSelectCicloDeVida === false && (
              <Button
                className="campo-texto-cor-3 campo-select"
                onClick={() =>
                  setRevelarSelectCicloDeVida(!revelarSelectCicloDeVida)
                }
              >
                <div className="fonte-cor-1 label-campo campo-texto-select-tamanho">
                  {dsStatus}
                </div>
                <img
                  className={
                    revelarSelectCicloDeVida
                      ? 'campo-select-icone-ativado nao-selecionavel'
                      : 'campo-select-icone-desativado nao-selecionavel'
                  }
                  src={setaDropdown()}
                  alt="drop"
                />
              </Button>
            )}

            {revelarSelectCicloDeVida === true && (
              <SelectGenerico
                paramRota="fat_solicitacao_status"
                paramCampo1={null}
                paramCampo2={null}
                paramCampo3={null}
                paramCampo4={null}
                setCodigo={setCdStatus}
                setDescricao1={setDsStatus}
                setDescricao2={setDummy}
                setDescricao3={setDummy}
                setDescricao4={setDummy}
                setRevelarSelect={setRevelarSelectCicloDeVida}
                placeholder={dsStatus}
                sufixo=""
               />
            )}
          </div>
          <Col>
            <div>
              <Form.Label>
                {' '}
                <div className="fonte-cor-1 label-campo">
                  Protocolo de contestação
                </div>{' '}
              </Form.Label>
              <OverlayTrigger
                key="top"
                delay={{ show: 500, hide: 250 }}
                placement="top"
                overlay={
                  <Tooltip
                    className="tooltip-campos-solicitacao"
                    id="tooltip-top"
                  >
                    Digite o Protocolo de contestação
                  </Tooltip>
                }
              >
                <Form.Control
                  className="campo-texto-cor-3 campo-texto"
                  type="text"
                  maxLength="30"
                  value={protocoloContestacao}
                  name="ds_protocolo_contestacao"
                  onChange={(e) => setProtocoloContestacao(e.target.value)}
                  placeholder="Digite o protocolo da contestacao"
                />
              </OverlayTrigger>
            </div>
          </Col>
        </Form.Row>

        <Form.Row className="usuario-dados-corpo-linha">
          <div className="corpo-dados-solicitacao">
            <Form.Label>
              <div className="fonte-cor-1 label-campo">
                Previsão de conclusão
              </div>
            </Form.Label>
            <OverlayTrigger
              key="top"
              delay={{ show: 500, hide: 250 }}
              placement="top"
              overlay={
                <Tooltip
                  className="tooltip-campos-solicitacao"
                  id="tooltip-top"
                >
                  Selecione a previsão de conclusão
                </Tooltip>
              }
            >
              <div className="calendario-z-index">
                <Calendario
                  data={previsaoConclusao}
                  setData={setPrevisaoConclusao}
                  dataMax={dataMax}
                  dataMin={dataMin}
                 />
              </div>
            </OverlayTrigger>
          </div>
          <Col>
            <div>
              <Form.Label>
                <div className="fonte-cor-1 label-campo">Data de conclusão</div>
              </Form.Label>
              <OverlayTrigger
                key="top"
                delay={{ show: 500, hide: 250 }}
                placement="top"
                overlay={
                  <Tooltip
                    className="tooltip-campos-solicitacao"
                    id="tooltip-top"
                  >
                    Selecione a data de alteração
                  </Tooltip>
                }
              >
                <Calendario
                  data={dataConclusao}
                  setData={setDataConclusao}
                  dataMax={dataMax}
                  dataMin={dataMin}
                 />
              </OverlayTrigger>
            </div>
          </Col>
        </Form.Row>

        <Form.Row className="usuario-dados-corpo-linha">
          <div className="corpo-textarea-solicitacao">
            <Form.Label>
              <div className="fonte-cor-1 label-campo">Motivo da alteração</div>
            </Form.Label>
            <OverlayTrigger
              key="top"
              delay={{ show: 500, hide: 250 }}
              placement="top"
              overlay={
                <Tooltip
                  className="tooltip-campos-solicitacao"
                  id="tooltip-top"
                >
                  Digite o motivo da alteração
                </Tooltip>
              }
            >
              <Form.Control
                className="campo-texto-cor-3 campo-texto-area"
                as="textarea"
                rows="3"
                maxlength="500"
                value={motivoAlteracao}
                name="ds_telefone_empresa"
                onChange={(e) => setMotivoAlteracao(e.target.value)}
                placeholder="Motivo da alteração"
                ref={register({ required: true, min: 3 })}
              />
            </OverlayTrigger>
          </div>
        </Form.Row>
        <Form.Row className="espaco-reativar-linha">
          <Col>
            <>
              {cdStatus !== '' &&
              previsaoConclusao != '' &&
              dataConclusao != '' ? (
                <Button
                  type="submit"
                  className="botao-confirmar"
                  variant="success"
                  size="sm"
                >
                  <div className="fonte-cor-4">Confirmar</div>
                </Button>
              ) : (
                <Button className="botao-confirmar-desabilitado" size="sm">
                  <div className="fonte-cor-4">Confirmar</div>
                </Button>
              )}
              <Button
                className="botao-cancelar"
                variant="success"
                size="sm"
                onClick={() => handleCancelar()}
              >
                <div className="fonte-cor-2">Cancelar</div>
              </Button>
            </>
          </Col>
        </Form.Row>
      </div>
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="Sua solicitação foi enviada."
              mensagemBotao="Continuar"
            />
          </div>
        </div>
      )}
      {revelarMensagemAtencao && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemAtencao
              handleMensagemAtencao={handleMensagemAtencao}
              mensagemTitulo="Remover Linha?"
              mensagemBotao="Remover"
            />
          </div>
        </div>
      )}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
    </Form>
  )
}
